/* eslint-disable import/no-anonymous-default-export */
import { AnimationTab } from './AnimationTab';
import { type AnimationLight, type AnimationSummary } from '@wwf/sdk';

export default {
    list: AnimationTab,
    recordRepresentation: (record: AnimationSummary | AnimationLight) =>
        record.name ?? `${record.id}`,
};
